"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BUTTON_LABEL_READY = void 0;
exports.BUTTON_LABEL_READY = 'ファイルを選択';
